export enum AiWriterWorkflowsType {
  BlogPost = 'blogPost',
  SocialPost = 'socialPost'
}
